import { useState } from "react";
import dayjs from "dayjs";
import { useGetRMEMensualReporte } from "../../Services/RMEIndex";
import Logocolor from "../../Image/Logo.png";
import { formatCLP } from "../FuncionesGenerales/FormatoCLP";
import { TituloPrincipal, Input, SubTitulodos } from "../../Layouts/CustomStyles";
import {
  Box,
  Typography,
  CircularProgress,
  Grid,
   Card,
    CardContent,
    TextField,
  MenuItem,
} from "@mui/material";
import { GiMoneyStack, GiReceiveMoney,  GiPayMoney } from "react-icons/gi";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Cell,
  PieChart,
  Pie,
  ResponsiveContainer,
} from "recharts";



const CardResumenMensual = ({
  titulo,
  periodo,
  monto,
  tipo = "flujo", // 🔥 nuevo
  IconoPositivo = GiReceiveMoney,
  IconoNegativo = GiPayMoney,
}) => {

  const esNegativo = monto < 0;

  let backgroundColor;
  let colorTexto;
  let colorIcono;
  let Icono;

  // 🔥 LÓGICA INTELIGENTE
  if (tipo === "gasto") {
    backgroundColor = "#fdecea";
    colorTexto = "#c62828";
    colorIcono = "#d32f2f";
    Icono = IconoNegativo;

  } else if (tipo === "ingreso") {
    backgroundColor = "#e8f5e9";
    colorTexto = "#2e7d32";
    colorIcono = "#4caf50";
    Icono = IconoPositivo;

  } else {
    // flujo de caja (sí depende del signo)
    backgroundColor = esNegativo ? "#fdecea" : "#e8f5e9";
    colorTexto = esNegativo ? "#c62828" : "#2e7d32";
    colorIcono = esNegativo ? "#d32f2f" : "#4caf50";
    Icono = esNegativo ? IconoNegativo : IconoPositivo;
  }

  return (
    <Card sx={{
      backgroundColor,
      borderRadius: 3,
      boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
      transition: "transform 0.2s, box-shadow 0.2s",
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0px 6px 14px rgba(0,0,0,0.25)",
      },
    }}>
      <CardContent sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <Box sx={{ width: "80%" }}>
          <Typography variant="h6" sx={{ fontFamily: "Poppins", color: "#555" }}>
            {titulo}
          </Typography>

          <Typography variant="body2" sx={{ fontFamily: "Poppins", color: "#777" }}>
            {periodo.nombre_mes} {periodo.anio}
          </Typography>

          <Typography variant="h6" sx={{
            fontFamily: "Poppins",
            fontWeight: 600,
            color: colorTexto
          }}>
            {formatCLP(monto)}
          </Typography>
        </Box>

        <Icono size={60} color={colorIcono} />
      </CardContent>
    </Card>
  );
};

export const RmeIndex = () => {
    const [filtroRme, setFiltroRme] = useState({
  anio: dayjs().year(),
  mes: dayjs().month() + 1,
});

const {
  resumenMensual,
  loading,
} = useGetRMEMensualReporte(filtroRme);

const COLORS = [
  '#1976d2',
  '#ba51cc',
  '#5fbd64',
  '#e4914d',
  '#e27272',
  '#56aad8',
  '#e984d3',
  '#19d2a4',
  '#17b7bd'
];


const PeriodoMensual = resumenMensual?.periodo || {};
const totales = resumenMensual?.totales || {};
const totalesEERR =
  resumenMensual?.totales?.estado_resultado_historico ?? [];

const totalesFlujodecaja =
  resumenMensual?.totales?.flujo_caja_historico ?? [];

const GraficocomparativodeIngresosyGastos =
  resumenMensual?.totales?.comparativo_mensual ?? [];

  const distribucionGastos = resumenMensual?.totales?.distribucion_gastos || {};

const dataGastosPorCategoria =
  (distribucionGastos?.por_categoria ?? []).map(item => ({
    name: item.categoria,
    value: Number(item.total),
  }));

const dataGastosPorSucursal =
  (distribucionGastos?.por_sucursal ?? []).map(item => ({
    name: item.sucursal,
    value: Number(item.total),
  }));


  const distribucionIngresos = resumenMensual?.totales?.distribucion_ingresos || {};

const dataIngresosPorCategoria =
  (distribucionIngresos?.por_tipo ?? []).map(item => ({
    name: item.tipo,
    value: Number(item.total),
  }));

const dataIngresosPorSucursal =
  (distribucionIngresos?.por_sucursal ?? []).map(item => ({
    name: item.sucursal,
    value: Number(item.total),
  }));


const dataGraficoFlujoCaja =
  totalesFlujodecaja?.map(item => {
    
    // "March 2026" → ["March", "2026"]
    const [mesStr, anio] = item.periodo.split(" ");

    // mapa inglés → número
    const mesesMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };

    const fecha = new Date(anio, mesesMap[mesStr]);

    return {
      mesLabel: fecha.toLocaleDateString("es-CL", {
        month: "short",
      }),
      neto: item.saldo_final,
    };
  });

  const dataGraficoFlujoCajaMensual =
  totalesFlujodecaja?.map(item => {
    
    // "March 2026" → ["March", "2026"]
    const [mesStr, anio] = item.periodo.split(" ");

    // mapa inglés → número
    const mesesMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };

    const fecha = new Date(anio, mesesMap[mesStr]);

    return {
      mesLabel: fecha.toLocaleDateString("es-CL", {
        month: "short",
      }),
      neto: item.flujo_neto,
    };
  });

const dataGraficoIngresosGastos =
  GraficocomparativodeIngresosyGastos?.map(item => ({
    mes: item.periodo.nombre_mes,
    Ingresos: item.ingresos,
    Egresos: item.gastos,
  })) .reverse();

const dataGraficoEERR = (totalesEERR ?? [])
  .map(item => {
    const fecha = new Date(item.periodo.anio, item.periodo.mes - 1);

    return {
      mesLabel: fecha.toLocaleDateString("es-CL", {
       
        month: "short", 
      }),
      anio: item.periodo.anio,
      mesNumero: item.periodo.mes,
      utilidad: item.utilidad,
    };
  })
  .sort((a, b) => {
    if (a.anio !== b.anio) return a.anio - b.anio; 
    return a.mesNumero - b.mesNumero;
  });

// ✅ último mes = actual
const utilidadActual =
  dataGraficoEERR?.[dataGraficoEERR.length - 1]?.utilidad ?? 0;

const flujoCajaActual =
  totalesFlujodecaja?.[totalesFlujodecaja.length - 1]?.saldo_final ?? 0;

  const flujoCajaMensual =
  totalesFlujodecaja?.[totalesFlujodecaja.length - 1]?.flujo_neto ?? 0;

const MESES = [
  "enero",
  "febrero",
  "marzo",
  "abril",
  "mayo",
  "junio",
  "julio",
  "agosto",
  "septiembre",
  "octubre",
  "noviembre",
  "diciembre",
];

const formatMillions = (value) => {
  if (value === 0) return '0';
  return `${(value / 1_000_000).toFixed(0)} MM`;
};

    if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "300px",
          gap: 2,
          position: "relative",
        }}
      >
        <CircularProgress size={90} thickness={4} sx={{ color: "#6fd385ff" }} />
        <Box
          component="img"
          src={Logocolor}
          alt="Logo"
          sx={{ width: "55px", height: "55px", position: "absolute", top: "90px" }}
        />
        <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
          Cargando reporte...
        </Typography>
      </Box>
    );
  }
    return(
        <>
        <Box
  sx={{
    justifyContent:'flex-end',
    display: "flex",
    gap: 2,
    mb: 3,
    alignItems: "center",
  }}
>
  {/* Año */}
  <TextField
    select
    label="Año"
    value={filtroRme.anio}
    onChange={(e) =>
      setFiltroRme((prev) => ({
        ...prev,
        anio: Number(e.target.value),
      }))
    }
    size="small"
    sx={{ ...Input, minWidth: 120 }}
  >
    {[ 2025, 2026, 2027, 2028].map((anio) => (
      <MenuItem key={anio} value={anio}>
        {anio}
      </MenuItem>
    ))}
  </TextField>

  {/* Mes */}
<TextField
  select
  label="Mes"
  value={filtroRme.mes}
  onChange={(e) =>
    setFiltroRme((prev) => ({
      ...prev,
      mes: Number(e.target.value),
    }))
  }
  size="small"
  sx={{...Input, minWidth: 160 }}
>
  {MESES.map((nombreMes, index) => (
    <MenuItem key={index + 1} value={index + 1}>
      {nombreMes}
    </MenuItem>
  ))}
</TextField>

</Box>

<Box mb={3}>
     <Typography variant="h6" sx={{...TituloPrincipal, mt:2}}>
  Período  {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
</Box>
<Grid container spacing={2}>
  {/* Expense */}
  <Grid size={{xs:12, sm:4}}>
    <CardResumenMensual
      titulo="Egresos"
      periodo={PeriodoMensual}
      monto={totales.expense}
      Icono={GiMoneyStack}
      colorIcono="#e57373"
      tipo="gasto"
    />
  </Grid>

  {/* INGRESOS */}
  <Grid size={{xs:12, sm:4}}>
    <CardResumenMensual
      titulo="Ingresos"
      periodo={PeriodoMensual}
      monto={totales.income}
      Icono={GiReceiveMoney}
      colorIcono="#4caf50"
      tipo="ingreso"
    />
  </Grid>

  <Grid size={{xs:12, sm:4}}>
    <CardResumenMensual
      titulo="EERR Utilidad"
      periodo={PeriodoMensual}
      monto={utilidadActual}
      Icono={GiReceiveMoney}
      colorIcono="#4caf50"
        tipo="eerr"
    />
  </Grid>
  <Grid size={{xs:12, sm:6}}>
    <CardResumenMensual
      titulo="Saldo de Flujo caja al periodo"
      periodo={PeriodoMensual}
      monto={flujoCajaActual}
      Icono={GiReceiveMoney}
      colorIcono="#4caf50"
        tipo="flujo"
    />
  </Grid>
  <Grid size={{xs:12, sm:6}}>
    <CardResumenMensual
      titulo="Flujo de caja Mensual"
      periodo={PeriodoMensual}
      monto={flujoCajaMensual}
      Icono={GiReceiveMoney}
      colorIcono="#4caf50"
        tipo="flujo"
    />
  </Grid>

</Grid>

<Box>
  <Grid container spacing={2}>
    <Grid size={{xs:12, sm:6}}>
      <Box mt={4}>
 

  <Card sx={{ borderRadius: 3, p: 5 }}>
     <Typography variant="h6" sx={{ ...SubTitulodos, mb: 2 }}>
    Comparativo mensual de Ingresos y egresos
  </Typography>
    <ResponsiveContainer width="100%" height={385}>
      <BarChart data={dataGraficoIngresosGastos}>
        <XAxis dataKey="mes" tick={{ fontSize: 12 }}  />
        <YAxis tick={{ fontSize: 12 }} tickFormatter={formatMillions}/>
        <Tooltip formatter={(value) => formatCLP(value)} />
        <Legend />

        <Bar
          dataKey="Ingresos"
          fill="#4caf50"
          radius={[6, 6, 0, 0]}
        />

        <Bar
          dataKey="Egresos"
          fill="#e57373"
          radius={[6, 6, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  </Card>
</Box>

    </Grid>
    <Grid size={{xs:12,sm:6}}>
      <Box mt={4}>
 
  <Card sx={{ borderRadius: 3, p: 5 }}>
  <Typography variant="h6" sx={{ ...SubTitulodos, mb: 2 }}>
    Comparativa Estado resultado
  </Typography>

  <ResponsiveContainer width="100%" height={385}>
    <BarChart data={dataGraficoEERR}>
      
      {/* ✅ usar mesLabel */}
      <XAxis dataKey="mesLabel" tick={{ fontSize: 12 }} />

      <YAxis
        tick={{ fontSize: 12 }}
        tickFormatter={formatMillions}
      />

      <Tooltip formatter={(value) => formatCLP(value)} />

      <Bar dataKey="utilidad" radius={[6, 6, 0, 0]}>
        {dataGraficoEERR.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={
              index === dataGraficoEERR.length - 1
                ? "#2e7d32" // 🟢
                : entry.utilidad < 0
                ? "#e57373" // 🔴 
                : "#1976d2" // 🔵 
            }
          />
        ))}
      </Bar>

    </BarChart>
  </ResponsiveContainer>
</Card>

 
</Box>

    </Grid>
    <Grid size={{xs:12, sm:6}}>
      <Box mt={4}>
  

<Card sx={{ borderRadius: 3, p: 5 }}>
  <Typography variant="h6" sx={{ ...SubTitulodos, mb: 2 }}>
    Comparativa Saldo de Flujo caja acumulado
  </Typography>

  <ResponsiveContainer width="100%" height={385}>
    <BarChart data={dataGraficoFlujoCaja}>
      
      <XAxis 
        dataKey="mesLabel" // 🔥 FIX CLAVE
        tick={{ fontSize: 12 }} 
      />

      <YAxis 
        tick={{ fontSize: 12 }} 
        tickFormatter={formatMillions} 
      />

      <Tooltip 
        formatter={(value) => formatCLP(value)} 
      />

      <Bar dataKey="neto" radius={[6, 6, 0, 0]}>
        {dataGraficoFlujoCaja.map((entry, index) => {
          const esUltimo = index === dataGraficoFlujoCaja.length - 1;

          return (
            <Cell
              key={`cell-${index}`}
              fill={
                esUltimo
                  ? '#1976d2' 
                  : entry.neto < 0
                  ? '#e57373'
                  : '#19d260'
                  
              }
            />
          );
        })}
      </Bar>

    </BarChart>
  </ResponsiveContainer>
</Card>
</Box>


    </Grid>
     <Grid size={{xs:12, sm:6}}>
      <Box mt={4}>
  

<Card sx={{ borderRadius: 3, p: 5 }}>
  <Typography variant="h5" sx={{ ...SubTitulodos, mb: 2 }}>
    Comparativa Flujo de caja mensual
  </Typography>

  <ResponsiveContainer width="100%" height={385}>
    <BarChart data={ dataGraficoFlujoCajaMensual}>
      
      <XAxis 
        dataKey="mesLabel" // 🔥 FIX CLAVE
        tick={{ fontSize: 12 }} 
      />

      <YAxis 
        tick={{ fontSize: 12 }} 
        tickFormatter={formatMillions} 
      />

      <Tooltip 
        formatter={(value) => formatCLP(value)} 
      />

      <Bar dataKey="neto" radius={[6, 6, 0, 0]}>
        { dataGraficoFlujoCajaMensual.map((entry, index) => {
          const esUltimo = index ===  dataGraficoFlujoCajaMensual.length - 1;

          return (
            <Cell
              key={`cell-${index}`}
              fill={
                esUltimo
                  ? '#1976d2' 
                  : entry.neto < 0
                  ? '#e57373'
                  : '#19d260'
                  
              }
            />
          );
        })}
      </Bar>

    </BarChart>
  </ResponsiveContainer>
</Card>
</Box>


    </Grid>
  </Grid>
  <Grid container spacing={2} mt={5}>
    <Grid size={12}>
   <Card sx={{ borderRadius: 3, p: 4, mb: 4 }}>
  <Typography variant="h6" sx={{ ...SubTitulodos, mb: 2 }}>
    Distribución de egresos por Categoría
  </Typography>

 <ResponsiveContainer width="100%" height={600}>
    <PieChart>
      <Pie
        data={dataGastosPorCategoria}
        dataKey="value"
        nameKey="name"
          cx="50%"    
        cy="50%"
        outerRadius={220}
  paddingAngle={3}
  label={false}
        label={({  value }) => `${formatCLP(value)}`}

      >
        {dataGastosPorCategoria.map((_, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>

      <Tooltip formatter={(value) => formatCLP(value)} />

      <Legend
        layout="vertical"
        align="right"
        verticalAlign="middle"
      />
    </PieChart>
  </ResponsiveContainer>
</Card>


    </Grid>

    <Grid size={12}>
      <Card sx={{ borderRadius: 3, p: 4 }}>
  <Typography variant="h6" sx={{ ...SubTitulodos, mb: 2 }}>
    Distribución de egresos por Sucursal
  </Typography>

  <ResponsiveContainer width="100%" height={500}>
    <PieChart>
      <Pie
        data={dataGastosPorSucursal}
        dataKey="value"
        nameKey="name"
        cx="50%"             
        cy="50%"
          outerRadius={200}
  paddingAngle={2}
  label={false}
        label={({  value }) => `${formatCLP(value)}`}

      >
        {dataGastosPorSucursal.map((_, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>

      <Tooltip formatter={(value) => formatCLP(value)} />
      <Legend verticalAlign="middle" align="right" layout="vertical" />
    </PieChart>
  </ResponsiveContainer>
</Card>

    </Grid>
  </Grid>

   <Grid container spacing={2} mt={5}>
    <Grid size={12}>
   <Card sx={{ borderRadius: 3, p: 4, mb: 4 }}>
  <Typography variant="h6" sx={{ ...SubTitulodos, mb: 2 }}>
    Distribución de Ingresos por Categoría
  </Typography>

  <ResponsiveContainer width="100%" height={500}>
    <PieChart>
      <Pie
        data={dataIngresosPorCategoria}
        dataKey="value"
        nameKey="name"
          cx="50%"    
        cy="50%"
        outerRadius={200}
  paddingAngle={1}
  label={false}
        label={({  value }) => `${formatCLP(value)}`}
        

      >
        {dataIngresosPorCategoria.map((_, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>

      <Tooltip formatter={(value) => formatCLP(value)} />

      <Legend
        layout="vertical"
        align="right"
        verticalAlign="middle"
      />
    </PieChart>
  </ResponsiveContainer>
</Card>


    </Grid>

    <Grid size={12}>
      <Card sx={{ borderRadius: 3, p: 4 }}>
  <Typography variant="h6" sx={{ ...SubTitulodos, mb: 2 }}>
    Distribución de Ingresos por Sucursal
  </Typography>

  <ResponsiveContainer width="100%" height={500}>
    <PieChart>
      <Pie
        data={dataIngresosPorSucursal}
        dataKey="value"
        nameKey="name"
        cx="50%"              
        cy="50%"
         cx="50%"    
        cy="50%"
        outerRadius={200}
  paddingAngle={1}
  label={false}
        label={({  value }) => `${formatCLP(value)}`}
      >
        {dataIngresosPorSucursal.map((_, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>

      <Tooltip formatter={(value) => formatCLP(value)} />
      <Legend verticalAlign="middle" align="right" layout="vertical" />
    </PieChart>
  </ResponsiveContainer>
</Card>

    </Grid>
  </Grid>
</Box>


        
        
        </>
    )
}